import React from "react";
import styled from "styled-components";
import Flex from "../DefaultStyles/Flex";

interface SLineBox {
  minWidth?: number;
}

interface SValue extends SLineBox {
  hasDate?: boolean;
  disabled?: boolean;
}

interface CalendarLineBtnProps extends SValue {
  onClickEvent: () => void;
  value: string;
  initValue: string;
}

export default function CalendarLineBtn({
  onClickEvent,
  value,
  initValue,
  disabled,
  minWidth,
}: CalendarLineBtnProps) {
  return (
    <LineBox
      onClick={() => onClickEvent()}
      disabled={disabled}
      minWidth={minWidth}
    >
      <Flex gapSize={4}>
        <CalendarIcon className="material-symbols-outlined" disabled={disabled}>
          date_range
        </CalendarIcon>
        <Value hasDate={value !== initValue} disabled={disabled}>
          {value}
        </Value>
      </Flex>

      <CalendarIcon
        className="material-symbols-outlined"
        style={{ fontSize: 24 }}
        disabled={disabled}
      >
        arrow_drop_down
      </CalendarIcon>
    </LineBox>
  );
}

const LineBox = styled.button<SLineBox>`
  min-width: ${({ minWidth }) => (minWidth ? `${minWidth}px` : "160px")};
  width: ${({ minWidth }) => `${minWidth}px` ?? "100%"};
  height: 38px;
  border-radius: 3px;
  border: solid 1px #d4d9e1;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 7px 0 12px;

  &:disabled {
    border-color: ${({ theme }) => theme.buttonColor.lineDisabled};
    cursor: not-allowed;
  }
`;

const CalendarIcon = styled.span<SValue>`
  font-size: 18px;
  color: ${({ disabled, theme }) =>
    disabled ? theme.buttonColor.lineDisabled : "#858c97"};
`;

const Value = styled.span<SValue>`
  font-size: 14px;
  text-align: left;
  color: ${({ hasDate, theme, disabled }) =>
    disabled
      ? theme.buttonColor.lineDisabled
      : hasDate
      ? theme.color.gray800
      : theme.buttonColor.linePressed};
`;
